var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3069_9330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.57153 8.28577C8.57153 6.07663 10.3624 4.28577 12.5715 4.28577H30.8573L39.4287 12.8572V39.7143C39.4287 41.9235 37.6378 43.7143 35.4287 43.7143H12.5715C10.3624 43.7143 8.57153 41.9235 8.57153 39.7143V8.28577Z",
    fill: "url(#paint0_linear_3069_9330)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8573 12.8572L39.4287 12.8572L30.8573 4.28575L30.8573 10.8572C30.8573 11.9617 31.7527 12.8572 32.8573 12.8572Z",
    fill: "#F9827F"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.092 30.0001V21.6001H16.656C17.152 21.6001 17.6 21.7201 18 21.9601C18.408 22.1921 18.728 22.5121 18.96 22.9201C19.2 23.3281 19.32 23.7881 19.32 24.3001C19.32 24.8201 19.2 25.2881 18.96 25.7041C18.728 26.1201 18.408 26.4521 18 26.7001C17.6 26.9401 17.152 27.0601 16.656 27.0601H14.892V30.0001H13.092ZM14.868 25.4401H16.452C16.644 25.4401 16.816 25.3921 16.968 25.2961C17.12 25.1921 17.24 25.0561 17.328 24.8881C17.424 24.7201 17.472 24.5281 17.472 24.3121C17.472 24.0961 17.424 23.9081 17.328 23.7481C17.24 23.5801 17.12 23.4521 16.968 23.3641C16.816 23.2681 16.644 23.2201 16.452 23.2201H14.868V25.4401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9319 30.0001V21.6001H24.3759C24.9919 21.6001 25.5479 21.7041 26.0439 21.9121C26.5479 22.1121 26.9799 22.4001 27.3399 22.7761C27.7079 23.1441 27.9879 23.5841 28.1799 24.0961C28.3719 24.6081 28.4679 25.1761 28.4679 25.8001C28.4679 26.4161 28.3719 26.9841 28.1799 27.5041C27.9879 28.0161 27.7119 28.4601 27.3519 28.8361C26.9919 29.2041 26.5599 29.4921 26.0559 29.7001C25.5519 29.9001 24.9919 30.0001 24.3759 30.0001H20.9319ZM22.7319 28.6921L22.5399 28.3801H24.3159C24.6759 28.3801 24.9999 28.3201 25.2879 28.2001C25.5759 28.0721 25.8199 27.9001 26.0199 27.6841C26.2279 27.4601 26.3839 27.1881 26.4879 26.8681C26.5919 26.5481 26.6439 26.1921 26.6439 25.8001C26.6439 25.4081 26.5919 25.0561 26.4879 24.7441C26.3839 24.4241 26.2279 24.1521 26.0199 23.9281C25.8199 23.7041 25.5759 23.5321 25.2879 23.4121C24.9999 23.2841 24.6759 23.2201 24.3159 23.2201H22.5039L22.7319 22.9321V28.6921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0959 30.0001V21.6001H31.8959V30.0001H30.0959ZM30.9239 26.6641V25.1161H35.2679V26.6641H30.9239ZM30.9239 23.2201V21.6001H35.7719V23.2201H30.9239Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3069_9330",
    x1: 24.0001,
    y1: 43.7143,
    x2: 24.0001,
    y2: 4.28577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9827F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F33B34"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3069_9330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.00b4f2999b01f9ead10beef5af752d13.svg";
export { ForwardRef as ReactComponent };